// Auto-generated from button.spec.js
export default {
  "tagName": "ui-buttons",
  "types": [
    "styled",
    "vertical"
  ],
  "variations": [
    "floated",
    "compact",
    "size",
    "attached",
    "color",
    "separate",
    "equal-width"
  ],
  "attributes": [
    "styled",
    "floated",
    "compact",
    "size",
    "attached",
    "color",
    "vertical",
    "separate",
    "equal-width"
  ],
  "optionAttributes": {
    "subtle": "styled",
    "flat": "styled",
    "outline": "styled",
    "ghost": "styled",
    "left": "floated",
    "right": "floated",
    "compact": "compact",
    "mini": "size",
    "tiny": "size",
    "small": "size",
    "medium": "size",
    "large": "size",
    "big": "size",
    "huge": "size",
    "massive": "size",
    "top": "attached",
    "attached": "attached",
    "bottom": "attached",
    "red": "color",
    "orange": "color",
    "yellow": "color",
    "olive": "color",
    "green": "color",
    "teal": "color",
    "blue": "color",
    "violet": "color",
    "purple": "color",
    "pink": "color",
    "brown": "color",
    "grey": "color",
    "slate": "color",
    "two": "equal-width",
    "three": "equal-width",
    "four": "equal-width",
    "five": "equal-width",
    "six": "equal-width",
    "left-floated": "floated",
    "right-floated": "floated",
    "top-attached": "attached",
    "bottom-attached": "attached",
    "left-attached": "attached",
    "right-attached": "attached",
    "very-compact": "compact"
  },
  "propertyTypes": {
    "styled": "string",
    "floated": "string",
    "compact": "string",
    "size": "string",
    "attached": "string",
    "color": "string",
    "vertical": "boolean",
    "separate": "boolean",
    "equal-width": "string"
  },
  "allowedValues": {
    "styled": [
      "subtle",
      "flat",
      "outline",
      "ghost"
    ],
    "floated": [
      "left",
      "right"
    ],
    "compact": [
      "compact",
      "very"
    ],
    "size": [
      "mini",
      "tiny",
      "small",
      "medium",
      "large",
      "big",
      "huge",
      "massive"
    ],
    "attached": [
      "top",
      "attached",
      "bottom",
      "left",
      "right"
    ],
    "color": [
      "red",
      "orange",
      "yellow",
      "olive",
      "green",
      "teal",
      "blue",
      "violet",
      "purple",
      "pink",
      "brown",
      "grey",
      "slate"
    ],
    "equal-width": [
      "two",
      "three",
      "four",
      "five",
      "six"
    ]
  },
  "attributeClasses": [
    "styled",
    "attached",
    "color",
    "equal-width"
  ],
  "inheritedPluralVariations": [
    "size",
    "floated",
    "compact",
    "color",
    "styled",
    "attached"
  ]
};
